import { render, staticRenderFns } from "./DocumentsChartsDash.vue?vue&type=template&id=148e3b76&"
import script from "./DocumentsChartsDash.vue?vue&type=script&lang=js&"
export * from "./DocumentsChartsDash.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsChartsDash.vue?vue&type=style&index=0&id=148e3b76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports